import React, { useState, Fragment, useEffect } from "react";
import { Transition, Dialog } from "@headlessui/react";
import NavMobile from "shared/Navigation/NavMobile";
import ChangeLang from "shared/ChangeLang/ChangeLang";
import { useTranslation } from "react-i18next";

const SocialList = [
    {}
];

export interface MenuBarProps {
    navigationList: any[];
    currentKey: string;
}
const MenuBar: React.FC<MenuBarProps> = (props) => {
	const { t } = useTranslation();
    const { navigationList, currentKey } = props;
    const [isVisable, setIsVisable] = useState(false);

    useEffect(() => {
        setIsVisable(false);
    }, [window.location.pathname]);

    const handleOpenMenu = () => setIsVisable(true);
    const handleCloseMenu = () => setIsVisable(false);

    return (
        <>
            <div className="flex items-center">
                <button type="button" aria-label={t('common.open_menu')} onClick={handleOpenMenu} className="p-2.5 rounded-lg text-neutral-700 dark:text-neutral-300 focus:outline-none flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" viewBox="0 0 20 20" fill="currentColor" >
                        <path
                            fillRule="evenodd"
                            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                </button>
                <div className="pr-[12px]">
                    <ChangeLang />
                </div>
            </div>

            <Transition appear show={isVisable} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={handleCloseMenu}
                >
                    <div className="fixed inset-y-0 left-0 z-max flex h-full w-full max-w-sm outline-none focus:outline-none md:w-auto">
                        <React.Fragment>
                            <Transition.Child
                                as={Fragment}
                                enter="transition duration-100 transform"
                                enterFrom="opacity-0 -translate-x-14"
                                enterTo="opacity-100 translate-x-0"
                                leave="transition duration-150 transform"
                                leaveFrom="opacity-100 translate-x-0"
                                leaveTo="opacity-0 -translate-x-14"
                            >
                                <div className="relative z-10 h-full min-h-0 w-full max-w-sm">
                                    <NavMobile onClickClose={handleCloseMenu} navigationList={navigationList} currentKey={currentKey} />
                                </div>
                            </Transition.Child>
                            <Transition.Child
                                as={Fragment}
                                enter=" duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave=" duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Dialog.Overlay className="fixed inset-0 bg-neutral-900 bg-opacity-50" />
                            </Transition.Child>
                        </React.Fragment>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};

export default MenuBar;
